/** @format — Merge turn_saved server rows into the chat message list */

import { mapChatApiMessageToViewModel } from "./mapChatMessages";

const OPTIMISTIC_VOICE_ID = /^voice_(user|live)_/;

/**
 * Append persisted voice-turn messages and drop optimistic voice placeholders.
 * Handles server payloads with length 1 (user only) or 2 (user + assistant).
 */
export function mergeSavedVoiceMessagesIntoList(currentMessages, savedMessages, chatId) {
  const incoming = (savedMessages ?? [])
    .map((row) =>
      mapChatApiMessageToViewModel({
        ...row,
        room_id: row.room_id ?? row.chat_id ?? chatId,
      }),
    )
    .filter(Boolean);

  if (!incoming.length) return currentMessages ?? [];

  const known = new Set((currentMessages ?? []).map((message) => message.id));
  const additions = incoming.filter((message) => !known.has(message.id));
  if (!additions.length) return currentMessages ?? [];

  const withoutOptimistic = (currentMessages ?? []).filter(
    (message) => !OPTIMISTIC_VOICE_ID.test(String(message.id ?? "")),
  );

  return [...withoutOptimistic, ...additions];
}
